<template>
  <div class="job_opportunity">
    <div class="jpl_meta">
        <span>{{job.categories.commitment}}</span>
        <span>{{job.categories.location}}</span>
    </div>
    <h3><a :href="url">{{job.text}}</a></h3>
    <p v-html="this.parsedDesc"></p>      
    <a class="learn_more" :href="url">Apply Now</a>
  </div>
</template>

<script>
export default {
  name: "JobItem",
  props: ["job", "job_url"],
  computed: {
    url: function () {      
      // Change to lower case
      var str = this.job.text.toLowerCase();
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "ãàáäâáº½èéëêìíïîõòóöôùúüûñç·/_,:;";
      var to   = "aaaaaeeeeeiiiiooooouuuunc------";
      for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes
      
      return this.job_url + str + "/" + this.job.id;      
    },    
    parsedDesc: function () {
      let desc = document.createElement('div')
      desc.innerHTML = this.job.description
      desc.removeChild(desc.firstElementChild)
      return desc.innerHTML
    }
  }
}
</script>
